'use es6';

import text from 'I18n/utils/unescapedText';
import ActionTypes from '../constants/ActionTypes';
import CheckGoodUsageErrorTypes from '../constants/CheckGoodUsageErrorTypes';
import GoodSubTypes from '../constants/GoodSubTypes';
import { closeCheckGoodUsageErrorAlert } from '../actions/GoodsActions';

var showNotification = function showNotification(notification) {
  return {
    type: ActionTypes.SHOW_APP_NOTIFICATION,
    meta: {
      notification: notification
    }
  };
};

var removeNotification = function removeNotification(id) {
  return {
    type: ActionTypes.REMOVE_APP_NOTIFICATION,
    meta: {
      removeNotification: {
        id: id
      }
    }
  };
};

export default (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      var prevState = getState();
      var result = next(action);

      switch (action.type) {
        case ActionTypes.CHECK_GOOD_USAGE:
          {
            if (action.error) {
              var _action$payload = action.payload,
                  errorId = _action$payload.errorId,
                  errorType = _action$payload.errorType,
                  good = _action$payload.good;
              var isForUninstall = errorType === CheckGoodUsageErrorTypes.ATTEMPTED_UNINSTALL;
              var titleTextKey;

              if (good && good.get('subType') === GoodSubTypes.CUSTOM_MODULE) {
                titleTextKey = isForUninstall ? 'errorCheckingModuleUsageForUninstall' : 'errorCheckingModuleUsage';
              } else {
                titleTextKey = isForUninstall ? 'errorCheckingTemplateUsageForUninstall' : 'errorCheckingTemplateUsage';
              }

              dispatch(showNotification({
                id: errorId,
                type: 'danger',
                titleText: text("managePurchases." + titleTextKey + ".titleText"),
                closeable: true,
                onClose: function onClose() {
                  return dispatch(closeCheckGoodUsageErrorAlert(errorId));
                }
              }));
            }

            break;
          }

        case ActionTypes.CHECK_GOOD_USAGE_ERROR_ALERT_DISMISSED:
          {
            var _errorId2 = action.payload.errorId;

            if (_errorId2) {
              dispatch(removeNotification(_errorId2));
            } else {
              var errorIds = prevState.managePurchases.get('checkGoodUsageErrorIds').keySeq();
              errorIds.forEach(function (_errorId) {
                return dispatch(removeNotification(_errorId));
              });
            }

            break;
          }

        default:
          break;
      }

      return result;
    };
  };
});